// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"iQ-z","inlineTitle":"jQ-z","sponsoredAdsWrapper":"kQ-z","marketplaceRecosWrapper":"lQ-z"};